import { datadogRum } from '@datadog/browser-rum';

import useAuth from '@/hooks/useAuth';

import Constants from '@/constants';

interface UseIsValidPlanNameProps {
  onlyCheckName?: boolean;
  onInvalidName?: () => void;
}

/** Validate a training plan name and assigned operator. */
const useIsValidPlanName = (props: UseIsValidPlanNameProps) => {
  const { onInvalidName, onlyCheckName = false } = props;
  const { data: auth } = useAuth();
  const userRoles = auth?.roles ?? {};

  const isValidPlanName = (planName?: string, assignedOperator?: string) => {
    const userIsStakeholder = Object.hasOwn(
      userRoles,
      Constants.USER_ROLES.STAKEHOLDER,
    );
    const noAssignedOperatorAndUserIsNotStakeholder =
      !assignedOperator && !userIsStakeholder;

    const nameCheck = !!planName && !!assignedOperator;

    const checkWithStakeholder =
      !!planName && !noAssignedOperatorAndUserIsNotStakeholder;

    const valid = onlyCheckName ? nameCheck : checkWithStakeholder;

    if (!valid) {
      onInvalidName?.();
      console.error('invalid name or missing operator');
      datadogRum.addError(
        new Error(
          `Build plans error - no plan name or no operator: ${JSON.stringify({
            planName,
            assignedOperator,
          })}`,
        ),
      );
    }

    return valid;
  };

  return isValidPlanName;
};

export default useIsValidPlanName;
